export default __webpack_public_path__ + "static/media/authImg.62a1fc2c.webp";